var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66634 1.2735L8.72634 0.333496L4.99967 4.06016L1.27301 0.333496L0.333008 1.2735L4.05967 5.00016L0.333008 8.72683L1.27301 9.66683L4.99967 5.94016L8.72634 9.66683L9.66634 8.72683L5.93967 5.00016L9.66634 1.2735Z",
    fill: "#E26C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.399ec8cc5e0757cd4fa37b73e6e9f3a7.svg";
export { ForwardRef as ReactComponent };